import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchclientReport } from "../../redux/actions/authActions";
import DashboardLayout from "../dashboard/DashboardLayout";
import SortableTable from "../../Pages/Components/SortableTable";
import SearchBar from "../../Pages/Components/SearchBar";
import MultiSelectDropdown from "../../Pages/Components/MultiSelectDropdown";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const ClientWiseReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const [selectedClients, setSelectedClients] = useState([]);

  const {
    loading,
    data = [],
    error,
  } = useSelector((state) => state.clientReport);

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    dispatch(fetchclientReport(userInfo.access_token));
  }, [dispatch, userInfo]);
  const uniqueClientNames = Array.from(
    new Set(data.map((d) => d.client_name))
  ).map((name) => ({
    value: name,
    label: name,
  }));

  const filteredData = data.filter((client) => {
    const matchesSearch = client.client_name
      ?.toLowerCase()
      .includes(searchText.toLowerCase());
    const matchesDropdown =
      selectedClients.length === 0 ||
      selectedClients.some((sel) => sel.value === client.client_name);
    return matchesSearch && matchesDropdown;
  });

  return (
    <DashboardLayout>
      <div className="max-w-full mx-auto">
        <div className="flex items-center space-x-3 py-4">
          <button onClick={() => navigate(-1)} className="hover:text-gray-800">
            <FaArrowLeft size={20} />
          </button>
          <h2 className="text-2xl font-bold text-amber-600 mb-1">
            {" "}
            Client Wise Redemption Statistics
          </h2>
        </div>

        {/* Search Bar */}
        {!loading && !error && data.length > 0 && (
          <div className="mb-2 w-1/2 flex flex-col md:flex-row items-center justify-start gap-4">
            <SearchBar
              className=""
              value={searchText}
              onChange={setSearchText}
              placeholder="Search by Client"
            />
            <MultiSelectDropdown
              label="Filter by Client"
              options={uniqueClientNames} // Already [{ value, label }]
              selectedValues={selectedClients} // Already [{ value, label }]
              setSelectedValues={(selectedOptions) => {
                setSelectedClients(selectedOptions || []);
              }}
            />
          </div>
        )}
        {selectedClients.length > 0 && (
          <div className="mb-4">
            <div className="text-md font-bold text-gray-950 py-2">
              Selected Clients:
            </div>
            <div className="flex flex-wrap gap-2">
              {selectedClients.map((client) => (
                <span
                  key={client.value}
                  className="bg-amber-300 text-gray-950 px-3 py-2 rounded-full text-sm font-medium"
                >
                  {client.label}
                </span>
              ))}
            </div>
          </div>
        )}
        {loading && <p>Loading...</p>}

        {error && <p className="text-red-600">{error}</p>}

        {!loading && !error && filteredData.length === 0 && (
          <p>No client data available.</p>
        )}

        {!loading && !error && filteredData.length > 0 && (
          <div className="mt-4 max-w-full mx-auto  border border-b-amber-500 rounded-lg">
            <SortableTable
              columns={[
                { key: "client_name", label: "Client Name", sortable: true },
                {
                  key: "total_orders",
                  label: "Total Orders",
                  sortable: true,
                  align: "center",
                },
                {
                  key: "total_quantity",
                  label: "Total Quantity",
                  sortable: true,
                  align: "center",
                },
                {
                  key: "total_billed_amount",
                  label: "Billed Amount",
                  sortable: true,
                  align: "right",
                },
                {
                  key: "total_payment_done",
                  label: "Payment Done",
                  sortable: true,
                  align: "right",
                },
                {
                  key: "total_pending_payment",
                  label: "Pending Payment",
                  sortable: true,
                  align: "right",
                },
                {
                  key: "total_orders_delivered",
                  label: "Orders Delivered",
                  sortable: true,
                  align: "center",
                },
                {
                  key: "total_orders_pending",
                  label: "Orders Pending",
                  sortable: true,
                  align: "center",
                },
              ]}
              data={filteredData}
              renderRow={(client) => (
                <tr
                  key={client.client_id}
                  className="hover:bg-amber-50 hover:text-gray-950 hover:font-semibold "
                >
                  <td className="py-4 px-2 border-b">{client.client_name}</td>
                  <td className="py-4 px-2 border-b">{client.total_orders}</td>
                  <td className="py-4 px-2 border-b">
                    {client.total_quantity}
                  </td>
                  <td className="py-4 px-2 border-b">
                    ₹{client.total_billed_amount}
                  </td>
                  <td className="py-4 px-2 border-b">
                    ₹{client.total_payment_done}
                  </td>
                  <td className="py-4 px-2 border-b">
                    ₹{client.total_pending_payment}
                  </td>
                  <td className="py-4 px-2 border-b">
                    {client.total_orders_delivered}
                  </td>
                  <td className="py-4 px-2 border-b">
                    {client.total_orders_pending}
                  </td>
                </tr>
              )}
            />
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ClientWiseReport;
